// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__pzO3W"};